import Api from '@/services/api'
import map from 'lodash/map'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {},
    articleDetails: {},
    requestStatus: '',
    requestMsg: '',
    optionList: []
  },

  mutations: {
    setRequestStatus (state, payload) {
      state.requestMsg = payload.msg
      state.requestStatus = payload.status
    },

    setList (state, records) {
      state.list = []
      state.list = map(records, 'family')
    },

    setListMeta (state, meta) {
      state.listMeta = meta
    },

    refreshList (state) {
      state.list = []
    },
    setOptionList (state, data) {
      state.optionList = []
      map(data, record => {
        state.optionList.push(
          {
            text: record.title,
            value: record.id

          }
        )
      })
    }
  },

  actions: {
    async getList ({ commit }) {
      let apiKey = process.env.VUE_APP_GOOGLE_FONTS_API_KEY
      await Api.get(`https://www.googleapis.com/webfonts/v1/webfonts?key=${apiKey}`)
        .then(response => {
          commit('setList', response.data.items)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    }

    // async update ({ commit }, params) {
    //   const config = {
    //     headers: { 'content-type': 'multipart/form-data' }
    //   }
    //   let id = params.get('id')
    //   await Api.post(`admin/free-to-play/live/${id}`, params, config)
    //     .then(response => {
    //       let payload = { msg: 'Poll updated.', status: 'success' }
    //       commit('setRequestStatus', payload)
    //     })
    //     .catch(error => {
    //       let payload = { msg: error.response.data.message, status: 'error' }
    //       commit('setRequestStatus', payload)
    //     })
    // },

  }
}
